import { useEffect, useRef, useState } from "react";
import api from "../../configs/api";
import { useAuth } from "../../context/AuthContext";
import { useScrollLock } from "../../hooks/useScrollLock";
import { showError, showSuccess } from "../../utils/toastUtils.js";

const InteriorLeadFormModal = ({ open, onClose, property }) => {
  const { user } = useAuth();
  const modalRef = useRef(null);

  useScrollLock(open);

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const [location, setLocation] = useState("");

  useEffect(() => {
    if (open && user) {
      setFullName(user.fullName || "");
      setEmail(user.email || "");
      setPhone(user.phone || "");
    }

    if (open && property) {
      setLocation(property.location || "");
    }
  }, [open, user, property]);

  if (!open || !property) return null;

  const handleOverlayClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      onClose();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await api.post("/interior-leads", {
        fullName,
        email,
        phone,
        propertyName: property.title,
        propertyType: property.propertyType,
        location,
      });

      showSuccess("Interior lead submitted successfully!");
      onClose();
    } catch (err) {
      console.error(err);
      showError("Failed to submit lead");
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/40 z-[9999] flex items-center justify-center p-4"
      onMouseDown={handleOverlayClick}
    >
      <div
        ref={modalRef}
        className="bg-white w-full max-w-lg rounded-xl p-6 relative shadow-lg"
        onMouseDown={(e) => e.stopPropagation()} // Prevent bubbling
      >
        {/* Close Button */}
        <button
          className="absolute top-4 right-4 text-gray-500 hover:text-black"
          onClick={onClose}
        >
          ✕
        </button>

        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Contact Builder
        </h2>
        <p className="text-sm text-gray-500 mb-4">
          You are enquiring about: <strong>{property.title}</strong>
        </p>

        {/* FORM */}
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Full Name */}
          <div>
            <label className="block text-sm text-gray-600 mb-1">
              Full Name
            </label>
            <input
              type="text"
              className="w-full border rounded-lg px-3 py-2"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm text-gray-600 mb-1">Email</label>
            <input
              type="email"
              className="w-full border rounded-lg px-3 py-2"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          {/* Phone */}
          <div>
            <label className="block text-sm text-gray-600 mb-1">
              Phone Number
            </label>
            <input
              type="text"
              className="w-full border rounded-lg px-3 py-2"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
            />
          </div>

          {/* Location */}
          <div>
            <label className="block text-sm text-gray-600 mb-1">
              Property Location
            </label>
            <input
              type="text"
              className="w-full border rounded-lg px-3 py-2"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
            />
          </div>

          {/* Submit */}
          <button
            type="submit"
            className="w-full bg-red-600 hover:bg-red-700 text-white py-2 rounded-lg font-medium"
          >
            Submit 
          </button>
        </form>
      </div>
    </div>
  );
};

export default InteriorLeadFormModal;
